<template>
  <BaseModalLocal
    ref="modalRef"
    v-bind="bindings"
    class="base-modal-confirm"
    :horizontal-buttons="horizontalButtons"
    @close="$emit('close')"
    @back="$emit('back')"
    @input="$emit('input', $event)"
    @cancel="$emit('cancel')"
    @submit="$emit('submit')"
  >
    <template #default="{ isOpen }">
      <div class="base-modal-confirm__wrapper">
        <img
          v-if="imageLocal"
          class="base-modal-confirm__image-local"
          :class="{'base-modal-confirm__image': !noMarginImgLocal}"
          :src="imageLocal"
          :alt="imageAlt"
          :width="imageSize"
          :height="imageSize"
        />
        <SvgIcon
          v-else-if="svg"
          class="base-modal-confirm__image"
          :name="svg.name"
          :style="svg.style"
        />
        <UiText
          v-if="c_title"
          class="base-modal-confirm__title"
          font="body-h2"
          color="typography-title01"
        >
          <div v-html="c_title" />
        </UiText>
        <UiText
          v-if="c_text"
          tag="p"
          class="base-modal-confirm__description"
          font="body-text-small"
          color="typography-body01"
          :align-center="!textLeft"
        >
          <div v-html="c_text" />
        </UiText>
        <slot :is-open="isOpen" />
      </div>
    </template>
    <!--Props should be more then enough-->
    <template #controls="{ onCancel, onSubmit, close: closeModal, isLoading }">
      <slot
        name="controls"
        :on-cancel="onCancel"
        :on-submit="onSubmit"
        :close="closeModal"
        :is-loading="isLoading"
      />
    </template>
    <template #cancel="{ onCancel }">
      <slot name="cancel" :on-cancel="onCancel" />
    </template>
    <template #submit="{ onSubmit }">
      <slot name="submit" :on-submit="onSubmit" />
    </template>
  </BaseModalLocal>
</template>

<script>
import BaseModalLocal from '@/components/Base/Modal/Local'
import {
  allModalsProps,
  bindings_allModalsProps,
  bindings_localModalAndItsDescendantsProps,
  localModalAndItsDescendantsProps
} from '@/components/Base/Modal/sharedProps'

// .$children[0].open()
export default {
  name: 'BaseModalConfirm',
  components: { BaseModalLocal },
  mixins: [
    bindings_allModalsProps,
    bindings_localModalAndItsDescendantsProps,
  ],
  props: {
    imageAlt: { type: String, default: 'picture' },
    svg: { type: Object, validator: (svgObj) => 'name' in svgObj },
    imageLocal: { type: String },
    imageSize: { type: Number, default: 104 },
    titleType: { type: String, default: '' },
    textType: { type: String, default: '' },
    title: { type: String },
    text: { type: String },
    textLeft: { type: Boolean, default: false },
    theme: { type: String },
    noMarginImgLocal: { type: Boolean, default: false },
    ...localModalAndItsDescendantsProps,
    ...allModalsProps,
  },
  computed: {
    bindings() {
      return {
        ...this.allModalsProps,
        ...this.localModalAndItsDescendantsProps,
        sizeSmall: true,
        colorGray: true,
      }
    },
    c_text() {
      return this.rawText ? this.rawText : this.$t(this.text)
    },
    c_title() {
      return this.rawTitle ? this.rawTitle : this.$t(this.title)
    },
  },
  methods: {
    async open() {
      return await this.$refs.modalRef.$open()
    },
    close() {
      this.$refs.modalRef.$close()
    },
    async $open() {
      return await this.open()
    },
    async $asyncOpen() {
      /** returns resolve fn, use after your async action */
      return await this.$refs.modalRef.$asyncOpen()
    },
    $close() {
      this.close()
    },
    $submit() {
      return this.$refs.modalRef.$submit()
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
